import React from 'react';
import { Alert, Input, Form, Select, message, notification, Table, Card, Tooltip, Icon } from 'antd';
import PaymentTriggerForm from '../PaymentTriggerForm';
import withSpin from 'components/withSpin';
import axios from 'axios';
import apiPath from 'apiPath';
import { formItemLayout, tailFormItemLayout } from './formItemLayout.js';
import SaveButton from 'components/SaveButton';
import moment from 'components/momentWithZone';


class DepositForm extends React.Component {
    state = {
        cabins: [],
        incentives: [],
        incentivesdeadline: null,
        cabinSelected: false,
        cabinOne: null,
        cabinTwo: null,
        cabinThree: null,
        early_dep_incentive: null,
        depositDue: null,
        bookingId: null,
        saveDisable: false,
        saveReallyDisable: false,
        isWaitList: false,
        voyageInfo: null,
        voyageName: "",
        voyageCode: "",
    }

    //handle cabin preferences form submit
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.isSubmitting();
        this.props.form.validateFields((err, values) => {

            /*
            let cabinUId = {
                "Outside Double": 48,
                "Inside Double": 53,
                "Inside Triple": 51,
                "Outside Triple": 50
            }
            //need to inser the interger value here so replacing string with correct integer value from the cabins table
            values.CabinPref1 = cabinUId[values.CabinPref1]
            values.CabinPref2 = cabinUId[values.CabinPref2]
            values.CabinPref3 = cabinUId[values.CabinPref3]
            */

            if (values.CabinPref1 === values.CabinPref2 || values.CabinPref2 === values.CabinPref3 || values.CabinPref1 === values.CabinPref3) {
                this.props.isSubmitted();
                return notification.error({
                    message: 'Please provide three different preferences.',
                    duration: 0
                });
            }
            if("early_dep_incentive" in values && values["early_dep_incentive"] === ""){
                this.props.isSubmitted();
                return notification.error({
                    message: 'Please select an Early Deposit Gift.',
                    duration: 0
                });
            }
            if (this.state.depositDue === ".00") {
                //post cabin pref
                this.postCabinPreferences(values);
                //post resco change trip
                //this.postTripChange();
            } else {
                //just post cabin pref
                this.postCabinPreferences(values)

            }

        })
    }

    postTripChange = () => {
        axios.get(apiPath + '/vantiv/changeTrip', { withCredentials: true }).then(result => {
            this.props.isSubmitted();
            this.setState({ cabinSelected: true })
        }).catch(error => {
            this.props.isDoneLoading();
            notification.error({
                message: error.message,
                duration: 0
            });
            console.log(error);
        })
    }

    //post cabin preferences that the user selects.  this unhide deposit section
    postCabinPreferences = (values) => {
        var that = this;
        var thevalues = values;

        if(!this.state.saveDisable){
            axios.put(apiPath + '/deposit/postCabinPreferences', values, { withCredentials: true }).then(result => {

                new Promise((resolve, reject) => {
                    if(that.state.incentives.length > 0 && that.state.depositDue === ".00"){
                        axios.put(apiPath + '/deposit/postIncentive', {'early_dep_incentive': thevalues.early_dep_incentive}, { withCredentials: true }).then(result => {
                            resolve();
                        }).catch(err => {
                            console.log(err);
                            reject({ message: <span>Unable to save early deposit gift selection.</span> });
                        });
                    }
                    else{
                        resolve();
                    }
                }).then(result => {
                    that.props.isSubmitted();
                    notification.success({
                        message: 'Thank you for choosing your cabin preferences',
                        description: <span>If you have a deposit due, please pay it down below.  You will not be able to access MyVoyage Portal until you do so. If you do not have a deposit due, visit <a target="blank" href="https://portal.semesteratsea.org">this link.</a></span>,
                        duration: 0
                    });
                    that.setState({
                        cabinSelected: true,
                        saveDisable: true,
                        saveReallyDisable: true
                    })
                    window.scrollTo(0, 9999);
                }).catch(error => {
                    that.props.isDoneLoading();
                    notification.error({
                        message: error.message,
                        duration: 0
                    });
                    console.log(error);
                });
            }).catch(error => {
                this.props.isDoneLoading();
                notification.error({
                    message: error.message,
                    duration: 0
                });
                console.log(error);
            })
        }
        else{
            that.props.isSubmitted();
            that.setState({
                cabinSelected: true,
                saveDisable: true,
                saveReallyDisable: true
            })
            window.scrollTo(0, 9999);
        }
    }

    //load deposits table and check for required params(deposit code)
    loadDeposit = () => {
        return axios.get(apiPath + '/deposit/loadDeposit', { withCredentials: true }).then(result => {
            if (result.data[0].CabinPref1 !== null && result.data[0].CabinPref2 !== null && result.data[0].CabinPref3 !== null) {
                this.setState({
                    saveDisable: true,
                    cabinSelected: true
                })
            }

            /*
            let cabinName = {
                48: "Outside Double",
                53: "Inside Double",
                51: "Inside Triple",
                50: "Outside Triple"
            }
            result.data[0].CabinPref1 = cabinName[result.data[0].CabinPref1]
            result.data[0].CabinPref2 = cabinName[result.data[0].CabinPref2]
            result.data[0].CabinPref3 = cabinName[result.data[0].CabinPref3]
            */

            //will also need to set state for cabins if they are all not null.  then show payment section. otherwise, keep it hidden
            this.setState({
                depositDue: result.data[0].DepositDue,
                bookingId: result.data[0].BookingId,
                cabinOne: result.data[0].CabinPref1,
                cabinTwo: result.data[0].CabinPref2,
                cabinThree: result.data[0].CabinPref3,
                early_dep_incentive: result.data[0].early_dep_incentive
            })
        }).catch(error => {
            console.log(error);
            message.error('Invalid credentials');
            this.props.history.push('/')
        });
    }

    //load in cabins avaible to the user's event id
    loadCabins = () => {
        return axios.get(apiPath + '/deposit/loadCabins', { withCredentials: true }).then(result => {
            this.setState({ cabins: result.data });
        })
    }

    loadIncentives = () => {
        return axios.get(apiPath + '/deposit/loadIncentives', { withCredentials: true }).then(result => {
            this.setState({
                incentivesdeadline: result.data.deadline,
                incentives: result.data.incentives,
            });
        })
    }

    //get waitlist status
    checkIfWaitlist = () => {
		return axios.get(apiPath+'/iswaitlist', {withCredentials: true}).then(response => {
			this.setState({
				isWaitList: response.data
			});
		});
    }

    //get voyage name and code
    loadVoyage = () => {
        return axios.get(apiPath + '/currentvoyage', { withCredentials: true }).then(result => {
            this.setState({
                voyageInfo: result.data.EventList.Event,
                voyageName: result.data.EventList.Event.Name,
                voyageCode: result.data.EventList.Event.Code,
            });
        });
    }

    //only let student check out to payment page if the amount is for $1,000
    preCheckout = () => {
        return new Promise((resolve, reject) => {
            if (!isNaN(this.refs.amount.value) && (this.refs.amount.value === this.state.depositDue || this.refs.amount.value === this.state.depositDue)) {
                //we need to save the selection, if there is one
                if(this.state.incentives.length > 0){
                    axios.put(apiPath + '/deposit/postIncentive', {'early_dep_incentive': this.state.early_dep_incentive}, { withCredentials: true }).then(result => {
                        resolve();
                    }).catch(err => {
                        console.error(err);
                        reject({ message: <span>Unable to save early deposit gift selection.</span> });
                    });
                }
                else{
                    resolve();
                }
            } else {
                reject({ message: <span>Invalid payment amount.  Payment must be ${this.state.depositDue}</span> });
            }
        });
    }

    getCabinTypeFromProps = (props) => {
        if (!this.props.bookingLoaded) return this.setState({ cabinType: null });
        const cabinTransaction = props.transactions
            .find(transaction => transaction.BaseMessage.toLowerCase().indexOf('cabin') !== -1);
        if (!cabinTransaction) return this.setState({ cabinType: 'Unknown' });
        this.setState({ cabinType: cabinTransaction.BaseMessage.split('Cabin:')[1] });
    }

    formatDollarAmount = (amount) => parseFloat(Math.round((amount) * 100) / 100).toFixed(2)

    //add comma to numbers as well as 2 decimal points past zero
    numberWithCommas = (x) => {
        let y = parseFloat(Math.round(x * 100) / 100).toFixed(2)
        return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    componentDidMount() {
        var theprops = this.props;
        this.props.isLoading();
        this.getCabinTypeFromProps(this.props);

        this.loadCabins()
        .then(this.loadDeposit)
        .then(this.checkIfWaitlist)
        .then(this.loadVoyage)
        .then(this.loadIncentives)
        .finally(function(){
            theprops.isDoneLoading();
        });
    }
    componentWillReceiveProps(nextProps) { this.getCabinTypeFromProps(nextProps); }

    render() {
        let cabins = this.state.cabins
        const { getFieldDecorator } = this.props.form;
        let amount = this.state.amount || 0;
        const columns = [
            { title: 'Cabin Type', dataIndex: 'CabinName', RowKey: 'CabinName' },
            { title: 'Cabin Price', dataIndex: 'Cabin', RowKey: 'Cabin', render: this.numberWithCommas },
            { title: 'Fuel', dataIndex: 'Fuel', RowKey: 'Fuel', render: this.numberWithCommas },
            { title: 'Tuition', dataIndex: 'Tuition', RowKey: 'Tuition', render: this.numberWithCommas },
            { title: 'Total', dataIndex: 'Price', RowKey: 'Price', render: this.numberWithCommas }
        ]

        return (
            //first a student will pay, then be asked to select their cabin if callback is successfull and payment is for $1,000
            <div>
                <h1>Cabin Preference & Deposit</h1>
                <br />
                <br />

                {this.state.depositDue !== ".00" && this.state.isWaitList &&
                    <Alert showIcon type="info"
                        message="Notice"
                        description={"You are making a deposit to be on the waitlist for the " + this.state.voyageName +" voyage. You must select your cabin preference and place your deposit before you can view the rest of the portal."} />
                }
                {this.state.depositDue === ".00" && !this.state.isWaitList &&
                <Alert showIcon type="info"
                    message="Notice"
                    description={"Your academic institution will pay a deposit on your behalf to put you on the waitlist for the " + this.state.voyageName + " voyage.  Please select your cabin preferences and you will be allowed to access the portal."} />
                }
                {this.state.depositDue !== ".00"  && !this.state.isWaitList &&
                    <Alert showIcon type="info"
                        message="Notice"
                        description="You must select your cabin preference and place your deposit before you can view the rest of the portal." />
                }
                {this.state.depositDue === ".00" && !this.state.isWaitList &&
                    <Alert showIcon type="info"
                        message="Notice"
                        description="You do not owe a deposit.  Please select your cabin preferences and you will be allowed to access the portal." />
                }
                <br />
                <Card>
                    <div>
                        {/* <Alert showIcon type="info"
                        message="Cabin Type Preferences"
                        description={<span>Please select your top three cabin preferences below. Semester at Sea assigns cabin preferences on a first come, first served basis. If  your first choice is full, we will place you on the waitlist for your first choice and try to assign you to your second or third cabin preferences in order. If all cabin preferences are full you will be assigned to an available cabin type.  You may only be placed on one cabin type waitlist. You will have a cabin type preference associated with your account until cabin type assignments are finalized one week prior to embarkation.  <strong>The confirmation deposit solidifies your enrollment and a space on board the ship - it does not confirm any specific cabin assignment.</strong>   Please refer to section 6 of the <a href="http://www.semesteratsea.org/wp-content/uploads/2016/07/Ticket-Contract-July-2016.pdf" target="blank">ticket contract</a> for cabin assignment policies.<br /><br /> </span>} /> */}
                        {/* description={<div><span>Please note that this section indicates your <strong>cabin type <i>preference</i></strong> and is <font style={{textDecorationLine: 'underline'}} >NOT</font> a <strong>finalized cabin <i>assignment</i>.</strong> Final cabin assignments are not made until 1 week prior to embarkation. Students will learn their cabin number and roommate at embarkation. Semester at Sea will make every effort possible to accommodate all cabin type preferences. Should Semester at Sea need to change your cabin type preference at the time of assigning cabins for any reason, you will be notified directly by Program Administration. Cabin assignments are at the sole discretion of Semester at Sea - please refer to Section 6 of the <a href="http://www.semesteratsea.org/wp-content/uploads/2016/07/Ticket-Contract-July-2016.pdf" target="blank">ticket contract</a> for cabin assignment policies.</span> <br /><br /> <span>If the cabin type preference listed below is not what you chose when placing your confirmation deposit, don’t worry! Your preferred cabin type may be full, in which case you have been placed on a waitlist. Cabin preference changes will be considered in the order of deposit, and can occur all the way up until two weeks prior to embarkation. Questions about cabins? E-mail <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a>.</span></div>} /> */}
                        <span>
                            Please select your top three cabin preferences below. Semester at Sea assigns cabin preferences on a first come, first served basis. If  your first choice is full, we will place you on the waitlist for your first choice and try to assign you to your second or third cabin preferences in order. If all cabin preferences are full you will be assigned to an available cabin type.  You may only be placed on one cabin type waitlist. You will have a cabin type preference associated with your account until cabin type assignments are finalized one week prior to embarkation.
                            {this.state.isWaitList &&
                                <strong> The confirmation deposit solidifies your position on the waitlist for the {this.state.voyageName} voyage - it does not confirm a place on the ship or a specific cabin assignment. </strong>
                            }
                            {!this.state.isWaitList &&
                                <strong> The confirmation deposit solidifies your enrollment and a space on board the ship - it does not confirm any specific cabin assignment. </strong>
                            }
                            Please refer to section 6 of the <a href="http://www.semesteratsea.org/wp-content/uploads/2016/07/Ticket-Contract-July-2016.pdf" target="blank">ticket contract</a> for cabin assignment policies.  Cabin price includes all meals aboard the ship. Even on days in port.<br /><br />
                        </span>
                        <br />
                        <Table
                            columns={columns}
                            bordered={true}
                            pagination={false}
                            size='small'
                            dataSource={cabins.map(cabin => {
                                return cabin
                            })} />
                        <br />
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Item label="First preference" {...formItemLayout} className="inResco">
                                {getFieldDecorator('CabinPref1', {
                                    initialValue: this.state.cabinOne !== null ? this.state.cabinOne : ''
                                })(
                                    <Select>
                                        {cabins.map(cabin =>
                                            <Select.Option key={cabin.cgoUId} value={cabin.cgoUId}>{cabin.CabinName} - ${this.numberWithCommas(cabin.Price)}</Select.Option>
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label="Second preference" {...formItemLayout} className="inResco">
                                {getFieldDecorator('CabinPref2', {
                                    initialValue: this.state.cabinTwo !== null ? this.state.cabinTwo : ''
                                })(
                                    <Select>
                                        {cabins.map(cabin =>
                                            <Select.Option key={cabin.cgoUId} value={cabin.cgoUId}>{cabin.CabinName} - ${this.numberWithCommas(cabin.Price)}</Select.Option>
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label="Third preference" {...formItemLayout} className="inResco">
                                {getFieldDecorator('CabinPref3', {
                                    initialValue: this.state.cabinThree !== null ? this.state.cabinThree : ''
                                })(
                                    <Select>
                                        {cabins.map(cabin =>
                                            <Select.Option key={cabin.cgoUId} value={cabin.cgoUId}>{cabin.CabinName} - ${this.numberWithCommas(cabin.Price)}</Select.Option>
                                        )}
                                    </Select>
                                )}
                            </Form.Item>

                            {this.state.incentives.length > 0 &&
                                <div>
                                    <p style={{marginBottom: '0px', marginTop: '25px', textAlign: 'center', fontWeight: 'bold'}}>Thank you for planning ahead! Select a free gift for depositing before {moment(this.state.incentivesdeadline).format('MMM. D, YYYY')}.</p>
                                    <p style={{marginBottom: '15px', textAlign: 'center'}}>All selections are final.</p>
                                    <Form.Item label="Early Deposit Gift" {...formItemLayout} className="inResco" style={{position: 'relative'}}>
                                    {getFieldDecorator('early_dep_incentive', {
                                        initialValue: this.state.early_dep_incentive !== null ? this.state.early_dep_incentive : ''
                                    })(
                                        <Select onChange={(newvalue) => this.setState({early_dep_incentive: newvalue})}>
                                            {this.state.incentives.map(i =>
                                                <Select.Option key={i.id} value={i.id}>
                                                    <Tooltip title={i.incentive_description}>
                                                        {i.incentive} <Icon type="question-circle" />
                                                    </Tooltip>
                                                </Select.Option>
                                            )}
                                        </Select>
                                    )}
                                    </Form.Item>
                                </div>
                            }



                            <Form.Item {...tailFormItemLayout}>
                                <SaveButton
                                    loading={this.props.getStatus().submitting}
                                    disabled={this.state.saveReallyDisable}
                                    />
                            </Form.Item>
                        </Form>





                    </div>
                </Card>
                <br />
                <Alert showIcon type="info"
                    message="Cancellation Policy"
                    description={<span>Please review cancellation policies <a target="blank" href="https://www.semesteratsea.org/admission-aid/payments-cancellations/">here</a></span>} />
                <br />
                {this.state.cabinSelected === true && this.state.depositDue !== ".00" &&
                    <div>
                        <Alert showIcon type="warning"
                            message={<span>Please submit a ${this.state.depositDue} deposit to confirm your participation.  This is your first payment towards program fees</span>}
                            description={
                                <div>
                                    <input type="hidden" ref="amount" name="amount" value={parseFloat(Math.round(amount * 100) / 100).toFixed(2)} />
                                    <Input
                                        prefix="$"
                                        onChange={(e) => this.setState({ amount: e.target.value })}
                                        onBlur={(e) => {
                                            if (!isNaN(parseFloat(Math.round(amount * 100) / 100).toFixed(2))) {
                                                e.target.value = parseFloat(Math.round(amount * 100) / 100).toFixed(2)
                                            }
                                        }}
                                        defaultValue={parseFloat(Math.round(amount * 100) / 100).toFixed(2)} />
                                    <PaymentTriggerForm showIcon
                                        buttonText="Make a Payment"
                                        orderno_prefix='DEP'
                                        preCheckout={this.preCheckout}
                                        bookingId={this.state.bookingId}
                                        total={amount} />
                                </div>
                            } />
                    </div>
                }
            </div>
        );
    }
}

export default withSpin(Form.create()(DepositForm));



// WEBPACK FOOTER //
// ./src/containers/Login/DepositForm.jsx